import { Instagram, Phone, Mail, Globe, MapPin } from "lucide-react";
import { HOTEL } from "../../data/content";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-forest-900 text-sand-200/80 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-3 gap-12 pb-14 border-b border-sand-100/10">
          <div>
            <div className="flex items-baseline gap-3 mb-5">
              <span className="font-serif text-3xl text-sand-100">Mecana</span>
              <span className="text-[0.6rem] tracking-[0.3em] uppercase text-earth-400 font-semibold">
                EcoHotel
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              {HOTEL.tagline}.
            </p>
          </div>

          <div>
            <h4 className="font-serif text-xl text-sand-100 mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              {[
                { l: "Our Story", h: "#story" },
                { l: "Stays", h: "#stays" },
                { l: "Experiences", h: "#experiences" },
                { l: "Gallery", h: "#gallery" },
                { l: "Reserve", h: "#contact" },
              ].map((i) => (
                <li key={i.h}>
                  <a
                    href={i.h}
                    data-testid={`footer-link-${i.l.toLowerCase().replace(/\s/g, "-")}`}
                    className="hover:text-earth-400 transition-colors"
                  >
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-xl text-sand-100 mb-5">Get in touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-earth-400 mt-0.5 shrink-0" />
                <span>{HOTEL.location}</span>
              </li>
              <li>
                <a href={`tel:${HOTEL.phoneDigits}`} className="flex items-center gap-3 hover:text-earth-400 transition-colors" data-testid="footer-phone">
                  <Phone size={16} className="text-earth-400 shrink-0" /> {HOTEL.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${HOTEL.email}`} className="flex items-center gap-3 hover:text-earth-400 transition-colors" data-testid="footer-email">
                  <Mail size={16} className="text-earth-400 shrink-0" /> {HOTEL.email}
                </a>
              </li>
              <li>
                <a href={HOTEL.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-earth-400 transition-colors" data-testid="footer-instagram">
                  <Instagram size={16} className="text-earth-400 shrink-0" /> @{HOTEL.instagram}
                </a>
              </li>
              <li>
                <a href={HOTEL.website} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-earth-400 transition-colors" data-testid="footer-website">
                  <Globe size={16} className="text-earth-400 shrink-0" /> jbdp.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-sand-200/50">
          <p>© {year} Mecana EcoHotel · Bahía Solano, Chocó — Colombia</p>
          <p>Set within tropical rainforests · edged by virgin shores</p>
        </div>
      </div>
    </footer>
  );
};
